import React from 'react'

import { CountryCode } from '../../types'
import { getCityTitle } from '../../utils/regionUtils'
import PuiTextField, { PuiTextFieldProps } from './PuiTextField'

export type CityTextFieldProps = PuiTextFieldProps & {
  readonly country: CountryCode
}

const CityTextField = ({ country, required, ...rest }: CityTextFieldProps) => (
  <PuiTextField
    inputProps={{ maxLength: 100 }}
    label={`${getCityTitle(country)}${required ? '*' : ''}`}
    {...rest}
  />
)

export default CityTextField
